"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledCloseBtn = exports.StyledMessage = exports.StyledTitle = exports.StyledBody = exports.StyleBase = exports.timeout = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var colors = _interopRequireWildcard(require("../style/colors"));

var fonts = _interopRequireWildcard(require("../style/fonts"));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

var timeout = 200;
exports.timeout = timeout;
var typeStyle = {
  info: (0, _styledComponents.css)(["background-color:", ";"], colors.primary),
  warning: (0, _styledComponents.css)(["background-color:", ";"], colors.yellow),
  danger: (0, _styledComponents.css)(["background-color:", ";"], colors.red),
  success: (0, _styledComponents.css)(["background-color:", ";"], colors.green)
};
var positionStyle = {
  topLeft: (0, _styledComponents.css)(["top:20px;left:20px;"]),
  topCenter: (0, _styledComponents.css)(["top:20px;left:33%;"]),
  topRight: (0, _styledComponents.css)(["top:20px;right:20px;"]),
  bottomRight: (0, _styledComponents.css)(["bottom:20px;right:20px;"]),
  bottomLeft: (0, _styledComponents.css)(["bottom:20px;left:20px;"]),
  bottomCenter: (0, _styledComponents.css)(["bottom:20px;left:33%;"])
};

var StyleBase = _styledComponents["default"].div.withConfig({
  displayName: "StyleBase",
  componentId: "z0wcl2-0"
})(["display:flex;align-items:center;border-radius:2px;width:422px;min-height:32px;box-shadow:0 0 11px 0 rgba(188,188,188,0.5);overflow:hidden;padding:13px 13px 13px 20px;position:fixed;background-color:", ";z-index:1000;", " &::before{content:'';width:3px;height:100%;display:block;position:absolute;left:0;background-color:", ";", "}&.notification-fade-enter{opacity:0;transform:", "}&.notification-fade-enter-active{opacity:1;transform:translateX(0);transition:opacity ", "ms,transform ", "ms;}&.notification-fade-exit{opacity:1;}&.notification-fade-exit-active{opacity:0;transform:", " transition:opacity ", "ms,transform ", "ms;}"], colors.white, function (_ref) {
  var position = _ref.position;
  return positionStyle[position];
}, colors.primary, function (_ref2) {
  var type = _ref2.type;
  return typeStyle[type];
}, function (_ref3) {
  var position = _ref3.position;
  return position === 'topCenter' || position === 'bottomCenter' ? "translateY(".concat(position === 'topCenter' ? '-100%' : '100%', " );") : "translateX(\n            ".concat(function (_ref4) {
    var position = _ref4.position;
    return position === 'topLeft' || position === 'bottomLeft' ? '-100%' : '100%';
  }, "\n          );");
}, timeout, timeout, function (_ref5) {
  var position = _ref5.position;
  return position === 'topCenter' || position === 'bottomCenter' ? "translateY(".concat(position === 'topCenter' ? '-100%' : '100%', " );") : "translateX(\n            ".concat(function (_ref6) {
    var position = _ref6.position;
    return position === 'topLeft' || position === 'bottomLeft' ? '-100%' : '100%';
  }, "\n          );");
}, timeout, timeout);

exports.StyleBase = StyleBase;

var StyledBody = _styledComponents["default"].div.withConfig({
  displayName: "StyledBody",
  componentId: "z0wcl2-1"
})(["margin-left:20px;max-width:360px;"]);

exports.StyledBody = StyledBody;

var StyledTitle = _styledComponents["default"].div.withConfig({
  displayName: "StyledTitle",
  componentId: "z0wcl2-2"
})(["font-family:", ";font-size:12px;color:", ";"], fonts.roboto, colors.titleColor);

exports.StyledTitle = StyledTitle;

var StyledMessage = _styledComponents["default"].div.withConfig({
  displayName: "StyledMessage",
  componentId: "z0wcl2-3"
})(["font-family:", ";font-size:12px;color:", ";"], fonts.roboto, colors.textColor);

exports.StyledMessage = StyledMessage;

var StyledCloseBtn = _styledComponents["default"].span.withConfig({
  displayName: "StyledCloseBtn",
  componentId: "z0wcl2-4"
})(["margin-left:auto;cursor:pointer;display:flex;"]);

exports.StyledCloseBtn = StyledCloseBtn;